import React from "react"

function PlusIcon() {
  return (
    <span className="anticon anticon-plus ">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke="CurrentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.666 10h6.667M10 13.333V6.667M7.5 18.333h5c4.166 0 5.833-1.666 5.833-5.833v-5c0-4.167-1.667-5.833-5.834-5.833h-5c-4.166 0-5.833 1.666-5.833 5.833v5c0 4.167 1.667 5.833 5.833 5.833z"
        />
      </svg>
    </span>
  )
}

export default PlusIcon
